/** Defaults when tenant settings omit colors */
export const PDF_DEFAULT_PRIMARY = '#DA2E09';
export const PDF_DEFAULT_SECONDARY = '#3949AB';

/** Shared letterhead logo box (pt) — fills the left header column without crowding the right column. */
export const PDF_HEADER_LOGO_WIDTH = 256;
export const PDF_HEADER_LOGO_HEIGHT = 96;
export const PDF_HEADER_LOGO_COL_FRAC = 0.46;

function normalizeHex(input, fallback) {
  const s = input != null ? String(input).trim() : '';
  if (/^#[0-9A-Fa-f]{6}$/.test(s)) return s;
  if (/^#[0-9A-Fa-f]{3}$/.test(s)) {
    const r = s[1];
    const g = s[2];
    const b = s[3];
    return `#${r}${r}${g}${g}${b}${b}`;
  }
  return fallback;
}

/**
 * Tenant branding.primaryColor / secondaryColor → PDF-safe hex values.
 */
export function resolvePdfBrandColors(branding = {}) {
  const b = branding || {};
  return {
    primary: normalizeHex(b.primaryColor, PDF_DEFAULT_PRIMARY),
    secondary: normalizeHex(b.secondaryColor, PDF_DEFAULT_SECONDARY),
  };
}

/** Top separator line under logo (neutral, not brand red). */
export function pdfHeaderRuleNeutral() {
  return '#444444';
}

/** Footer panel fill (white unless tenant adds `pdfFooterBackground` hex later). */
export function resolvePdfFooterSurfaceColor(branding = {}) {
  const raw = branding.pdfFooterBackground;
  const s = raw != null ? String(raw).trim() : '';
  if (!s || !/^#[0-9A-Fa-f]{3}([0-9A-Fa-f]{3})?$/.test(s)) return '#FFFFFF';
  return normalizeHex(s, '#FFFFFF');
}
